import { render } from "./ManageStaffs.vue?vue&type=template&id=92b356e4"
import script from "./ManageStaffs.vue?vue&type=script&lang=js"
export * from "./ManageStaffs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__